export const isValidPhoneNumberForUS = (phoneNumberString: string) => {
  const regex = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  return regex.test(phoneNumberString);
};
